import { Reducer } from 'redux';

import { SetNetworkContextAction } from '../../../domains/networkContext/actions.types';

import { CurrentNetworkContext } from './types';

const initialState: CurrentNetworkContext = null;

const reducer: Reducer<CurrentNetworkContext, SetNetworkContextAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_CONTEXT.SET':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
